// appliedUID status
// > products/active/../appliedUID/status
export const CAMPAIGN_APPLIED_UID_STATUS = {
  submitted: 'submitted',
  approved: 'approved',
  rejected: 'rejected',
};
